<template>
  <div id="page-report"
       class="container-fluid">
    <cash-book-filter :is-export-data="isExportData"
                      @get-cash-book="getCashBook"
                      @download-xls="downloadXls">
    </cash-book-filter>
    <div class="panel position-relative">
      <div class="row mb-3">
        <div class="col-md-12">
          <cash-book-list
            ref="xlslist"
            @has-export-data="hasExportData">
          </cash-book-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CashBookFilter from '@/views/FiscalDocs/CashBook/Filter';
  import CashBookList from '@/views/FiscalDocs/CashBook/List';

  export default {
    name: 'CashBook',
    components: {
      CashBookList,
      CashBookFilter
    },

    data() {
      return {
        isExportData: false
      };
    },

    mounted() {
      this.$store.commit('setPageTitle', 'CashBook');
    },

    methods: {
      getCashBook(filter) {
        this.$refs.xlslist.getXls(filter);
      },

      downloadXls(filter) {
        this.$refs.xlslist.download(filter);
      },

      hasExportData(result) {
        this.isExportData = result;
      }


    }

  };


</script>
